import { render, staticRenderFns } from "./RequestsApproval.vue?vue&type=template&id=d7245bf2&scoped=true&"
import script from "./RequestsApproval.vue?vue&type=script&lang=js&"
export * from "./RequestsApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7245bf2",
  null
  
)

export default component.exports